import {AxiosInstance} from 'axios';

/**
 * Header the backend requires on cookie-authenticated requests (see ResTokenCookie on the backend).
 * The ResToken rides in an HttpOnly cookie the browser attaches by itself, so the server needs proof
 * a request came from our own script rather than a forged cross-site one: a cross-site form cannot
 * add a custom header, and a cross-site fetch that does triggers a CORS preflight only our origin
 * passes. Only the header's presence is checked, never its value.
 */
export const CSRF_HEADER_NAME = 'X-Requested-With';
export const CSRF_HEADER_VALUE = 'XMLHttpRequest';

/**
 * The CSRF header, for callers that don't go through an axios instance (raw fetch).
 */
export function getCsrfHeaders(): Record<string, string> {
  return {[CSRF_HEADER_NAME]: CSRF_HEADER_VALUE};
}

/**
 * Attach the CSRF header to every request made through the instance.
 */
export function addCsrfInterceptor(instance: AxiosInstance) {
  instance.interceptors.request.use(config => {
    Object.assign(config.headers, getCsrfHeaders());
    return config;
  });
}
